import apiService from './api';



class ProfileService {
  constructor() {
    this.baseURL = '/api/v1/profile';

  }

  // Get complete user profile
  async getProfile() {
    try {
      
      
      const response = await apiService.request('/profile/profile');
      
      return response;
    } catch (error) {
      console.error('❌ ProfileService: Error fetching profile:', error);
      console.error('❌ ProfileService: Error details:', {
        message: error.message,
        status: error.status,
        response: error.response
      });
      throw error;
    }
  }

  // Update user profile
  async updateProfile(profileData) {
    try {
      const response = await apiService.request('/profile/profile', {
        method: 'PUT',
        body: profileData
      });
      return response;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  }

  // Get available avatars
  async getAvailableAvatars() {
    try {

      // Call avatar endpoint directly without authentication headers
      const url = `${this.baseURL}/avatars`;
      
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      return data.avatars;
    } catch (error) {
      console.error('❌ Error fetching avatars:', error);
      throw error;
    }
  }

  // Upload custom avatar
  async uploadAvatar(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await apiService.request('/profile/upload-avatar', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      console.error('Error uploading avatar:', error);
      throw error;
    }
  }

  // Get friends list
  async getFriends() {
    try {
      const response = await apiService.request('/profile/friends');
      return response.friends;
    } catch (error) {
      console.error('Error fetching friends:', error);
      throw error;
    }
  }

  // Send friend request
  async sendFriendRequest(friendEmail) {
    try {
      const response = await apiService.request('/profile/friends/request', {
        method: 'POST',
        body: {
          friend_email: friendEmail
        }
      });
      return response;
    } catch (error) {
      console.error('Error sending friend request:', error);
      throw error;
    }
  }

  // Respond to friend request
  async respondToFriendRequest(friendId, accept) {
    try {
      const response = await apiService.request(`/profile/friends/${friendId}/respond`, {
        method: 'POST',
        body: {
          accept: accept
        }
      });
      return response;
    } catch (error) {
      console.error('Error responding to friend request:', error);
      throw error;
    }
  }

  // Remove friend
  async removeFriend(friendId) {
    try {
      const response = await apiService.request(`/profile/friends/${friendId}`, {
        method: 'DELETE'
      });
      return response;
    } catch (error) {
      console.error('Error removing friend:', error);
      throw error;
    }
  }

  // Get user statistics
  async getStatistics() {
    try {
      const response = await apiService.request('/profile/statistics');
      return response.statistics;
    } catch (error) {
      console.error('Error fetching statistics:', error);
      throw error;
    }
  }

  // Get achievements
  async getAchievements() {
    try {
      const response = await apiService.request('/profile/achievements');
      return response.achievements;
    } catch (error) {
      console.error('Error fetching achievements:', error);
      throw error;
    }
  }

  // Log activity
  async logActivity(activityType, activityData = {}) {
    try {
      const response = await apiService.request('/profile/activity', {
        method: 'POST',
        body: {
          activity_type: activityType,
          activity_data: activityData
        }
      });
      return response;
    } catch (error) {
      console.error('Error logging activity:', error);
      throw error;
    }
  }

  // Update user statistics
  async updateStats(subject, stats = {}) {
    try {
      const response = await apiService.request('/profile/update-stats', {
        method: 'POST',
        body: {
          subject,
          quizzes_completed: stats.quizzesCompleted || 0,
          flashcards_created: stats.flashcardsCreated || 0,
          study_time_minutes: stats.studyTimeMinutes || 0
        }
      });
      return response;
    } catch (error) {
      console.error('Error updating statistics:', error);
      throw error;
    }
  }

  // Get recent activities
  async getRecentActivities(limit = 10) {
    try {
      const response = await apiService.request(`/profile/recent-activities?limit=${limit}`);
      return response;
    } catch (error) {
      console.error('Error fetching recent activities:', error);
      throw error;
    }
  }

  // Helper method to get avatar URL
  getAvatarUrl(filename) {
    return `${process.env.REACT_APP_API_URL || ''}/static/avatars/${filename}`;
  }

  // Helper method to get user avatar URL
  getUserAvatarUrl(avatarUrl) {
    if (!avatarUrl) return null;
    if (avatarUrl.startsWith('http')) return avatarUrl;
    return `${process.env.REACT_APP_API_URL || ''}${avatarUrl}`;
  }
}

export default new ProfileService(); 